// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/target.js';

import { paths } from '../generated/target';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('target', Original, paths);
